module.exports = __webpack_public_path__ + "static/img/interview.8ba5f007.png";